const queryKeys = {
  maintenanceSettings: 'maintenanceSettings',
  nationalNodeLogin: 'nationalNodeLogin'
};

export default queryKeys;
